import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldHalved, faChartLine, faStar, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

const tiers = [
  {
    label: 'Excellent',
    icon: faStar,
    color: '#22c55e',
    bg: 'rgba(34,197,94,0.08)',
    winRate: '70%+',
    consistency: '60%+',
    desc: 'Strong edge survived repeated blind testing',
  },
  {
    label: 'Good',
    icon: faShieldHalved,
    color: '#3b82f6',
    bg: 'rgba(59,130,246,0.08)',
    winRate: '60%+',
    consistency: '50%+',
    desc: 'Solid result, most tradeable strategies here',
  },
  {
    label: 'Fair',
    icon: faChartLine,
    color: '#f59e0b',
    bg: 'rgba(245,158,11,0.08)',
    winRate: '50%+',
    consistency: '40%+',
    desc: 'Some evidence of edge, proceed with caution',
  },
  {
    label: 'Poor',
    icon: faTriangleExclamation,
    color: '#ef4444',
    bg: 'rgba(239,68,68,0.08)',
    winRate: '<50%',
    consistency: '<40%',
    desc: 'No reliable edge demonstrated',
  },
];

export default function RobustnessTiersMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header"><span className="dot" /> Robustness Rating</div>
      <div className="platform-mock-body">
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {tiers.map((tier) => (
            <div
              key={tier.label}
              style={{
                display: 'grid',
                gridTemplateColumns: '90px 70px 70px 1fr',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.5rem 0.65rem',
                background: tier.bg,
                borderRadius: 6,
                border: `1px solid ${tier.color}22`,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                <FontAwesomeIcon icon={tier.icon} style={{ color: tier.color, fontSize: '0.7rem' }} />
                <span style={{ fontSize: '0.7rem', fontWeight: 600, color: tier.color }}>{tier.label}</span>
              </div>
              <div style={{ fontSize: '0.6rem', color: '#94a3b8' }}>
                WR {tier.winRate}
              </div>
              <div style={{ fontSize: '0.6rem', color: '#94a3b8' }}>
                Con {tier.consistency}
              </div>
              <div style={{ fontSize: '0.58rem', color: '#64748b' }}>
                {tier.desc}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="platform-mock-caption">Robustness rating combines win rate and consistency across all walk-forward windows.</div>
    </div>
  );
}
